import {
  PaymentProviderInterface,
} from '@/components/classes/PaymentProviders/Deposit/Interfaces/PaymentProviderInterface';
import PaymentProvider, {
  PaymentProviderConstructor,
} from '@/components/classes/PaymentProviders/Deposit/PaymentProvider';
import { PaymentProvider as PaymentProviderConstant } from '@/constants/paymentProvider';
import { requestPaymentLink } from '@/modules/casino/store/actions/paymentCheckout';

/**
 * Safecharge class
 * @extends PaymentProvider
 * @implements PaymentProviderInterface
 * @deprecated
 * this class is used to handle Safecharge AND Skrill payment providers
 */
class Safecharge extends PaymentProvider implements PaymentProviderInterface {
  constructor(data: PaymentProviderConstructor) {
    super(data);
    this.setType(data.paymentProvider ?? 0);
  }
  confirmPayment(): void {
    this.dispatch(
      requestPaymentLink(
        this.paymentDetails,
        this.getType() === PaymentProviderConstant.skrill,
      ),
    );
  }
}

export default Safecharge;
